var map = {
	"./404_error_page.png": 3936,
	"./Under Construction Illustration.png": 2754,
	"./account-hover.png": 1227,
	"./account-logo.png": 5576,
	"./account-management.png": 3484,
	"./announcement.png": 742,
	"./card-img.jpg": 8611,
	"./clinet-gv.jpg": 4204,
	"./cvs-icon.png": 2923,
	"./dashboard-hover.png": 6346,
	"./dashboard-icon.png": 8813,
	"./doc-icon.png": 5783,
	"./dummy-logo-0424-1.jpg": 4242,
	"./dummy-logo-0424-2.jpg": 4141,
	"./dummy-logo-0424-3.jpg": 8560,
	"./dummy-logo-1.png": 929,
	"./google-pixel-4.png": 1602,
	"./history-icon.svg": 8381,
	"./inbound-hover.png": 2373,
	"./inbound-icon.png": 2328,
	"./inquiry-hover.png": 3321,
	"./inquiry-report.png": 6001,
	"./inventory-hover.png": 4338,
	"./inventory-management.png": 2960,
	"./jpg-icon.png": 5962,
	"./login/announcement.png": 3100,
	"./login/bg.png": 2744,
	"./login/login-image.png": 1406,
	"./login/loginRightImage.svg": 8485,
	"./login/logo-white.png": 3192,
	"./login/logo.png": 5704,
	"./login/password.svg": 9950,
	"./login/userEmail.svg": 680,
	"./noimage.png": 8863,
	"./outbound-hover.png": 9330,
	"./outbound-icon.png": 373,
	"./pdf -icon.png": 9979,
	"./phone1.jpg": 202,
	"./png-icon.png": 4626,
	"./sort-down-active 1.svg": 7590,
	"./sort-icon.svg": 7059,
	"./sort-up-active 1.svg": 735,
	"./sphere-wms-logo.png": 378,
	"./svgList": 4445,
	"./svgList.tsx": 4445,
	"./timeline-circle.svg": 4195,
	"./warning.svg": 4137,
	"./xbox.png": 5792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;